import { render, staticRenderFns } from "./callback.page.vue?vue&type=template&id=41b86b97"
import script from "./callback.page.vue?vue&type=script&lang=js"
export * from "./callback.page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports